import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "tw-absolute tw-p-15px tw-flex tw-items-center tw-justify-between tw-w-full"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-text-12 sm:tw-text tw-font-semibold"
}, "Attivo", -1 /* HOISTED */);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-text-12 sm:tw-text tw-font-semibold"
}, "In attesa", -1 /* HOISTED */);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-text-12 sm:tw-text tw-font-semibold"
}, "Non idoneo", -1 /* HOISTED */);
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  "class": "tw-text-20 sm:tw-text-22 tw-font-semibold tw-mb-5px tw-flex tw-justify-between tw-items-center"
};
var _hoisted_7 = {
  "class": "price"
};
var _hoisted_8 = {
  key: 0,
  "class": "tw-hidden sm:tw-flex tw-items-center tw-gap-20px"
};
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = {
  "class": "tw-text-16 sm:tw-text-18 tw-font-medium"
};
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = {
  "class": "tw-flex tw-gap-x-15px tw-items-center property-details tw-flex-wrap sm:tw-flex-nowrap tw-bg-w-cultured tw-px-10px tw-py-5px tw-rounded-[10px] tw-w-full"
};
var _hoisted_13 = {
  key: 0,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_14 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_15 = ["src"];
var _hoisted_16 = {
  "class": "tw-font-semibold tw-text-12"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-text-12"
}, [/*#__PURE__*/_createTextVNode("m"), /*#__PURE__*/_createElementVNode("sup", null, "2")], -1 /* HOISTED */);
var _hoisted_18 = {
  key: 1,
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
};
var _hoisted_19 = {
  key: 2,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
}, null, -1 /* HOISTED */);
var _hoisted_21 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_22 = ["src"];
var _hoisted_23 = {
  key: 0,
  "class": "tw-font-semibold tw-text-12"
};
var _hoisted_24 = {
  key: 1
};
var _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-hidden sm:tw-block"
}, "Locali", -1 /* HOISTED */);
var _hoisted_26 = {
  key: 3,
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
};
var _hoisted_27 = {
  key: 4,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
}, null, -1 /* HOISTED */);
var _hoisted_29 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_30 = ["src"];
var _hoisted_31 = {
  key: 0,
  "class": "tw-font-semibold tw-text-12"
};
var _hoisted_32 = {
  key: 1
};
var _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  "class": "tw-hidden sm:tw-block"
}, "Bagni", -1 /* HOISTED */);
var _hoisted_34 = {
  key: 5,
  "class": "tw-block tw-border-l tw-border-w-secondary tw-border-solid tw-h-1/2"
};
var _hoisted_35 = {
  key: 6,
  "class": "tw-inline-flex tw-items-center tw-justify-center tw-flex-[1_0_auto]"
};
var _hoisted_36 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_37 = ["src"];
var _hoisted_38 = {
  "class": "tw-font-semibold tw-text-12"
};
import { BaseCard } from "@wikicasa-dev/components";
import { SUSPECT_STATE } from "@wikicasa/common/model/RealEstate";
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
import { formatLocaleNumber } from "@utils/NumberUtils";
import { useUtilities } from "@wkComposables/useUtilities";
export default /*#__PURE__*/_defineComponent({
  __name: 'RealEstateCard',
  props: {
    icons: {},
    realEstate: {},
    profileListingCard: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["reIdToDelete", "editListing"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useUtilities = useUtilities(),
      redirectTo = _useUtilities.redirectTo;
    var emits = __emit;
    var props = __props;
    var deleteClicked = function deleteClicked() {
      emits("reIdToDelete");
    };
    var editListing = function editListing() {
      emits("editListing", props.realEstate.realEstateId.toString());
    };
    var openDetail = function openDetail() {
      var _a;
      if (!((_a = props.realEstate.reMetadata) === null || _a === void 0 ? void 0 : _a.reMetadataSuspectStateID)) return;
      var fullDetailUrl = props.realEstate.baseUrl + props.realEstate.detailUrl;
      props.realEstate.reMetadata.reMetadataSuspectStateID === SUSPECT_STATE.VALIDATED ? redirectTo(fullDetailUrl, true) : console.error("Detail not available");
    };
    return function (_ctx, _cache) {
      var _a;
      return _openBlock(), _createBlock(_unref(BaseCard), {
        "class": _normalizeClass(["tw-flex tw-items-center tw-border-w-secondary tw-overflow-hidden !tw-flex-col sm:!tw-flex-row", {
          'tw-cursor-pointer': ((_a = _ctx.realEstate.reMetadata) === null || _a === void 0 ? void 0 : _a.reMetadataSuspectStateID) === _unref(SUSPECT_STATE).VALIDATED
        }]),
        "card-img-classes": "tw-shrink-0 tw-border-0 tw-relative tw-bg-w-lavender sm:max-md:!tw-w-[250px]",
        "card-body-classes": "!tw-p-15px sm:!tw-px-25px tw-bg-white tw-flex tw-flex-col tw-justify-between tw-h-[170px] sm:tw-h-full",
        onClick: openDetail
      }, {
        "card-image": _withCtx(function () {
          var _a, _b, _c;
          return [_ctx.profileListingCard ? (_openBlock(), _createElementBlock("div", _hoisted_1, [((_a = _ctx.realEstate.reMetadata) === null || _a === void 0 ? void 0 : _a.reMetadataSuspectStateID) === _unref(SUSPECT_STATE).VALIDATED ? (_openBlock(), _createBlock(BaseBadge, {
            key: 0,
            "badge-class": "tw-badge-w-validated"
          }, {
            "default": _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1 /* STABLE */
          })) : _createCommentVNode("v-if", true), ((_b = _ctx.realEstate.reMetadata) === null || _b === void 0 ? void 0 : _b.reMetadataSuspectStateID) === _unref(SUSPECT_STATE).PENDING ? (_openBlock(), _createBlock(BaseBadge, {
            key: 1,
            "badge-class": "tw-badge-w-warning"
          }, {
            "default": _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1 /* STABLE */
          })) : _createCommentVNode("v-if", true), ((_c = _ctx.realEstate.reMetadata) === null || _c === void 0 ? void 0 : _c.reMetadataSuspectStateID) === _unref(SUSPECT_STATE).BLOCKED ? (_openBlock(), _createBlock(BaseBadge, {
            key: 2,
            "badge-class": "tw-badge-w-danger"
          }, {
            "default": _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1 /* STABLE */
          })) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createElementVNode("img", {
            "class": "tw-object-cover tw-h-full tw-w-full",
            src: _ctx.realEstate.singlePhoto,
            alt: "real estate image"
          }, null, 8 /* PROPS */, _hoisted_5)];
        }),
        "card-description": _withCtx(function () {
          var _a, _b;
          return [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, "€ " + _toDisplayString(_unref(formatLocaleNumber)(_ctx.realEstate.price)), 1 /* TEXT */), _ctx.profileListingCard ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createCommentVNode(" DELETE "), _createElementVNode("button", {
            id: "delete-your-listing-btn",
            "data-cy": "delete-your-listing-btn",
            "class": "tw-bg-white tw-font-semibold tw-flex tw-justify-center tw-align-center",
            onClick: _withModifiers(deleteClicked, ["stop"])
          }, [_createVNode(BaseIcon, {
            "alt-attribute": "delete listing icon",
            "icon-class": "tw-m-0 !tw-h-[20px] !tw-w-[20px]",
            "icon-name": "delete-red.svg"
          })]), _createCommentVNode(" EDIT "), ((_a = _ctx.realEstate.reMetadata) === null || _a === void 0 ? void 0 : _a.reMetadataSuspectStateID) === _unref(SUSPECT_STATE).VALIDATED || ((_b = _ctx.realEstate.reMetadata) === null || _b === void 0 ? void 0 : _b.reMetadataSuspectStateID) === _unref(SUSPECT_STATE).PENDING ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "edit-your-listing-btn",
            "data-cy": "edit-your-listing-btn",
            "class": "tw-flex tw-bg-white tw-font-semibold tw-justify-center tw-align-center",
            onClick: _withModifiers(editListing, ["stop"])
          }, [_createVNode(BaseIcon, {
            "alt-attribute": "edit listing icon",
            "icon-class": "tw-m-0 !tw-h-[20px] !tw-w-[20px]",
            "icon-name": "edit-blue.svg"
          })])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true)]), _createElementVNode("h4", {
            "class": "tw-text-12 tw-font-regular tw-mt-0 tw-mb-0",
            innerHTML: _ctx.realEstate.typologyName
          }, null, 8 /* PROPS */, _hoisted_9), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.realEstate.streetName) + " " + _toDisplayString(_ctx.realEstate.streetNumber) + ", " + _toDisplayString(_ctx.realEstate.cityName), 1 /* TEXT */), _createElementVNode("p", {
            "class": "tw-hidden tw-text tw-leading-5 sm:tw-line-clamp-3 tw-mb-15px",
            style: {
              "overflow-wrap": "anywhere"
            },
            innerHTML: _ctx.realEstate.description
          }, null, 8 /* PROPS */, _hoisted_11), _createElementVNode("ul", _hoisted_12, [_ctx.realEstate.sqM && _ctx.realEstate.sqM > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
            src: props.icons.sqmIcon,
            height: "16",
            width: "16",
            alt: "sqm icon"
          }, null, 8 /* PROPS */, _hoisted_15)]), _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.realEstate.sqM), 1 /* TEXT */), _createTextVNode("  "), _hoisted_17])) : _createCommentVNode("v-if", true), _ctx.realEstate.rooms ? (_openBlock(), _createElementBlock("li", _hoisted_18)) : _createCommentVNode("v-if", true), _ctx.realEstate.rooms ? (_openBlock(), _createElementBlock("li", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
            src: props.icons.roomIcon,
            height: "16",
            width: "16",
            alt: "rooms icon"
          }, null, 8 /* PROPS */, _hoisted_22)]), _ctx.realEstate.rooms < 11 ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.realEstate.rooms), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_24, "10+")), _createTextVNode("  "), _hoisted_25])) : _createCommentVNode("v-if", true), _ctx.realEstate.bathrooms ? (_openBlock(), _createElementBlock("li", _hoisted_26)) : _createCommentVNode("v-if", true), _ctx.realEstate.bathrooms ? (_openBlock(), _createElementBlock("li", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, [_createElementVNode("img", {
            src: props.icons.bathroomIcon,
            height: "16",
            width: "16",
            alt: "bathrooms icon"
          }, null, 8 /* PROPS */, _hoisted_30)]), _ctx.realEstate.bathrooms < 6 ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.realEstate.bathrooms), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_32, "5+")), _createTextVNode("  "), _hoisted_33, _createTextVNode("  ")])) : _createCommentVNode("v-if", true), _ctx.realEstate.energyClass ? (_openBlock(), _createElementBlock("li", _hoisted_34)) : _createCommentVNode("v-if", true), _ctx.realEstate.energyClass ? (_openBlock(), _createElementBlock("li", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("img", {
            src: props.icons.energyClassIcon,
            height: "16",
            width: "16",
            alt: "energy class icon"
          }, null, 8 /* PROPS */, _hoisted_37)]), _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.realEstate.energyClass), 1 /* TEXT */)])) : _createCommentVNode("v-if", true)])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"]);
    };
  }
});